<div class="tooltip-borders mb-0 ms-0 me-0 border shadow-lg">
	<div
		class="tooltip-header p-2 fw-semibold fs-6 radious   {{ cor }}"
		[style]="'background-color:  ' + cor + ';color: ' + corTexto">
		<i class="ph-map-pin me-2 mb-1"></i>
		{{ nomePosto }}
	</div>
	<div class="tooltip-footer px-2 py-2 text-tertiary font-size-6 bg-white">
		<div *ngIf="deveMostrarMedia">
			<span class="fw-semibold"
				>{{ nomeVariavel }} médi{{ generoVariavel }}
				{{ isUnidadeNoValor ? '' : unidade }}:</span
			>
			<span [class]="'me-1' + ' text-tertiary'">
				{{ labelMedio }}{{ isUnidadeNoValor ? unidade : '' }}
			</span>
		</div>
		<div *ngIf="deveMostrarAcumulado">
			<span class="fw-semibold"
				>{{ nomeVariavel }} acumulada
				{{ isUnidadeNoValor ? '' : unidade }}:</span
			>
			<span [class]="'me-1' + ' text-tertiary'">
				{{ labelSoma }}{{ isUnidadeNoValor ? unidade : '' }}
			</span>
		</div>
		<div>
			<span class="fw-semibold"
				>{{ nomeVariavel }} máxim{{ generoVariavel }}
				{{ isUnidadeNoValor ? '' : unidade }}:</span
			>
			<span [class]="'me-1' + ' text-tertiary'">
				{{ labelMaximo }}{{ isUnidadeNoValor ? unidade : '' }}
			</span>
		</div>
		<div>
			<span class="fw-semibold"
				>{{ nomeVariavel }} mínim{{ generoVariavel }}
				{{ isUnidadeNoValor ? '' : unidade }}:</span
			>
			<span [class]="'me-1' + ' text-tertiary'">
				{{ labelMinimo }}{{ isUnidadeNoValor ? unidade : '' }}
			</span>
		</div>
	</div>
</div>
